// Modules
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Constants
import { APP_PATHS_CONSTANTS } from '@shared/constants';

// Guards
import { AuthGuard } from '@shared/guards/auth.guard';
import { GuestGuard } from '@shared/guards/guest.guard';
import { ForcedPasswordChangeGuard } from '@shared/guards/forced-password-change.guard';

// Components
import { LoginComponent } from '@public/pages/login/login.component';
import { PasswordChangeComponent } from '@private/pages/password-change/password-change.component';
import { ViewProfileComponent } from '@private/pages/view-profile/view-profile.component';
import { DashboardWrapperComponent } from '@private/pages/dashboard-wrapper/dashboard-wrapper.component';
import { PasswordRecoveryComponent } from '@public/pages/password-recovery/password-recovery.component';
import { ActivateAccountComponent } from '@public/pages/activate-account/activate-account.component';
import { ForcedPasswordChangeComponent } from '@public/pages/forced-password-change/forced-password-change.component';
import { DashboardComponent } from '@private/pages/dashboard/dashboard.component';

const routes: Routes = [
  // Main Path
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  // Login Path
  {
    path: APP_PATHS_CONSTANTS.ADMIN_LOGIN,
    component: LoginComponent,
    canActivate: [GuestGuard],
  },
  // Password Recovery Path
  {
    path: `${APP_PATHS_CONSTANTS.ADMIN_PASSWORD_RECOVERY}/:key`,
    component: PasswordRecoveryComponent,
    canActivate: [GuestGuard],
  },
  // User activation Path
  {
    path: `${APP_PATHS_CONSTANTS.ADMIN_USER_ACTIVATION}/:key`,
    component: ActivateAccountComponent,
    canActivate: [GuestGuard],
  },
  // Forced Password Change Path
  {
    path: 'forced-password-change',
    component: ForcedPasswordChangeComponent,
    canActivate: [ForcedPasswordChangeGuard],
  },
  // Private Paths
  {
    path: APP_PATHS_CONSTANTS.ADMIN_PRIVATE_WRAPPER,
    children: [
      // Dashboard
      {
        path: APP_PATHS_CONSTANTS.DASHBOARD_AUTO,
        component: DashboardComponent,
      },
      // Password Change
      {
        path: APP_PATHS_CONSTANTS.PASSWORD_CHANGE,
        component: PasswordChangeComponent,
      },
      // View Profile
      {
        path: APP_PATHS_CONSTANTS.VIEW_PROFILE,
        component: ViewProfileComponent,
      },
      // Car Insurance Module
      {
        path: APP_PATHS_CONSTANTS.CAR_INSURANCE_MODULE,
        loadChildren: () =>
          import('@car-insurance/car-insurance.module').then(
            m => m.CarInsuranceModule
          ),
      },
      // Cuentas
      {
        path: APP_PATHS_CONSTANTS.ACCOUNTS,
        loadChildren: () =>
          import('@accounts/account.module').then(m => m.AccountsModule),
      },
      // Fianza
      {
        path: APP_PATHS_CONSTANTS.FIANZA_MODULE,
        loadChildren: () =>
          import('@fianza/fianza.module').then(m => m.FianzaModule),
      },
      // Cartera
      {
        path: APP_PATHS_CONSTANTS.CARTERA_MODULE,
        loadChildren: () =>
          import('@modules/cartera/cartera.module').then(m => m.CarteraModule),
      },
      // Renovaciones
      {
        path: APP_PATHS_CONSTANTS.RENEWALS,
        loadChildren: () => import('@renewals-module/renewals.routes'),
      },
      // Multiproductos
      {
        path: APP_PATHS_CONSTANTS.MULTI_PRODUCTS,
        loadChildren: () =>
          import('@multi-products/multi-products.module').then(
            m => m.MultiProductsModule
          ),
      },
      // Usuarios
      {
        path: APP_PATHS_CONSTANTS.USERS_MODULE,
        loadChildren: () => import('@users/users.routes'),
      },
      // Siniestros
      {
        path: APP_PATHS_CONSTANTS.ACCIDENTS_MODULE,
        loadChildren: () =>
          import('@accidents/accidents.module').then(m => m.AccidentsModule),
      },
      // Cupones
      {
        path: APP_PATHS_CONSTANTS.COUPONS_CAMPAIGN,
        loadChildren: () => import('@coupons-campaign/coupons.routes'),
      },
      // Transporte
      {
        path: APP_PATHS_CONSTANTS.TRANSPORT,
        loadChildren: () =>
          import('@transport-module/transport.module').then(
            m => m.TransportModule
          ),
      },
      // Garantía de alquiler
      {
        path: APP_PATHS_CONSTANTS.RENT_GUARANTEE,
        loadChildren: () => import('@rent-guarantee/rent-guarantee.routes'),
      },
      // Viajes
      {
        path: APP_PATHS_CONSTANTS.TRAVEL,
        loadChildren: () => import('@travel/travel.routes'),
      },
      // Gestión de tarifa automóviles
      {
        path: APP_PATHS_CONSTANTS.AUTOMOBILE_PRICING,
        loadChildren: () =>
          import('@automobile-pricing/automobile-pricing.routes'),
      },
      // Setttings
      {
        path: APP_PATHS_CONSTANTS.SETTINGS,
        loadChildren: () => import('@settings-module/settings.routes'),
      },
    ],
    component: DashboardWrapperComponent,
    canActivate: [AuthGuard],
  },
  // Unexistent Paths
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
